import React from "react";
import "./Navbar.css";
import LanguageSwitcher from "./LanguageSwitcher";
import { NavLink, useNavigate } from "react-router-dom";
import Logo from "./images/logo-enano.png";

function Navbar() {
  const navigate = useNavigate();
  const handleNavLinkClick = (path) => {
    navigate(path);
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 100);
  };

  return (
    <div className="navbar">
      <div className="navbar-left">
        <NavLink to="/" onClick={() => handleNavLinkClick("/")}>
          <img src={Logo} alt="logo" className="logo-navbar" />
        </NavLink>
      </div>

      <div className="navbar-right">
        <LanguageSwitcher />
      </div>
    </div>
  );
}

export default Navbar;
